import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  FabricDetailBean,
  FabricDetailSearchCriteria,
  RestFabricDetailListRequest,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class FabricDetailListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }

  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };
  editFabricDetail = (e, rowData) => {
    if (e.detail === 1) this.props.editFabricDetail(rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let fabricDetail_list = this.props.fabricDetail_list;
    let fabricDetailData = this.props.fabricDetailData;
    fabricDetailData.fabricDetailTypeCode = this.props.fabricDetailTypeCode;
    return (
      <div>
        <div>
          <Row>
            <Col sm="2">
              {this.props.is3PL ? (
                <FormLabel>Item Detail Type Code</FormLabel>
              ) : (
                <FormLabel>Fabric Detail Type Code</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                name="fabricDetailTypeCode"
                type="text"
                onChange={this.onChange}
                value={fabricDetailData.fabricDetailTypeCode}
                disabled={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {this.props.is3PL ? (
                <FormLabel>ItemDetail</FormLabel>
              ) : (
                <FormLabel>FabricDetail</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                onChange={this.onChange}
                value={fabricDetailData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_Custom_3">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricDetailTypeCode")
                  }
                >
                  {this.props.is3PL ? "ItemDetailType" : "FabricDetailType#"}{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "fabricDetailTypeCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {fabricDetail_list.map((Info, index) => (
                <tr key={index}>
                  <td> {Info.fabricDetailTypeCode}</td>
                  <td className="td_attribute_width">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.editFabricDetail(e, Info)}
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {fabricDetail_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class FabricDetailEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.fabricCodeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.fabricCodeRef.current != null) {
      this.fabricCodeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  render() {
    let fabricDetailData = this.props.fabricDetailData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={fabricDetailData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.fabricCodeRef}
              name="code"
              type="text"
              onChange={this.onChange}
              value={fabricDetailData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            {this.props.is3PL ? (
              <FormLabel>ItemDetailTypeCode</FormLabel>
            ) : (
              <FormLabel>FabricDetailTypeCode</FormLabel>
            )}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="fabricDetailTypeCode"
              type="text"
              placeholder="Enter Code"
              onChange={this.onChange}
              value={fabricDetailData.fabricDetailTypeCode}
              disabled={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={fabricDetailData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={fabricDetailData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class FabricDetailList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      fabricDetailTypeCode: "",
      fabricDetail_list: [],
      response: {},
      pageTitle: "",
      moduleCaption: "",
      fabricDetailData: new FabricDetailBean(),
      pageList: new PageListBean(),
      criteria: new FabricDetailSearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isFabricDetailListFormOpen: true,
      isFabricDetailEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
      is3PL: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.setDefaultValues();
    let fabricDetailData = new FabricDetailBean();
    fabricDetailData.companyCode = this.companyCode;
    this.setState({ fabricDetailData: fabricDetailData });
    this.dataUploadUrl = appData.serviceURL + "/MasterRestService";
    this.loginSessionBean = JSON.parse(localStorage.getItem("session"));
    this.loadPage(1);
    //this.cleardata();
  }

  setDefaultValues = () => {
    let fabricDetailTypeCode = "";
    let pageTitle = "";
    let moduleCaption = "";
    if (this.props.moduleId == "fabricDetailAttribute") {
      fabricDetailTypeCode = this.state.is3PL
        ? "Item Construct"
        : "Fabric Construct";
      pageTitle = this.state.is3PL ? "Item Construct" : "Fabric Construct";
      moduleCaption = this.state.is3PL ? "Item Construct" : "Fabric Construct";
    } else if (this.props.moduleId == "designDirectionAttribute") {
      fabricDetailTypeCode = "Design Direction";
      pageTitle = "Design Direction";
      moduleCaption = "Design Direction";
    } else if (this.props.moduleId == "backedAttribute") {
      fabricDetailTypeCode = "Backed";
      pageTitle = "Backed";
      moduleCaption = "Backed";
    } else if (this.props.moduleId == "backedTypesAttribute") {
      fabricDetailTypeCode = "Backed Types";
      pageTitle = "Backed Types";
      moduleCaption = "Backed Types";
    } else if (this.props.moduleId == "boundBackTypesAttribute") {
      fabricDetailTypeCode = "Bounded Backed Types";
      pageTitle = "Bounded Backed Types";
      moduleCaption = "Bounded Backed Types";
    } else if (this.props.moduleId == "cardedOrCombedAttribute") {
      fabricDetailTypeCode = "Carded Or CombedYarn";
      pageTitle = "Carded Or CombedYarn";
      moduleCaption = "Carded Or CombedYarn";
    } else if (this.props.moduleId == "fabricDetailsAttribute") {
      fabricDetailTypeCode = this.state.is3PL
        ? "Item Details"
        : "Fabric Details";
      pageTitle = this.state.is3PL ? "Item Details" : "Fabric Details";
      moduleCaption = this.state.is3PL ? "Item Details" : "Fabric Details";
    } else if (this.props.moduleId == "fillingYarnsTexturedAttribute") {
      fabricDetailTypeCode = "Filing Yarn Textured";
      pageTitle = "Filing Yarn Textured";
      moduleCaption = "Filing Yarn Textured";
    } else if (this.props.moduleId == "fillingYarnsTwistedAttribute") {
      fabricDetailTypeCode = "Filing Yarn Twisted";
      pageTitle = "Filing Yarn Twisted";
      moduleCaption = "Filing Yarn Twisted";
    } else if (this.props.moduleId == "nappedAttribute") {
      fabricDetailTypeCode = "Napped";
      pageTitle = "Napped";
      moduleCaption = "Napped";
    } else if (this.props.moduleId == "printedAttribute") {
      fabricDetailTypeCode = "Printed";
      pageTitle = "Printed";
      moduleCaption = "Printed";
    } else if (this.props.moduleId == "warpYarnsAttribute") {
      fabricDetailTypeCode = "Warp Yarns";
      pageTitle = "Warp Yarns";
      moduleCaption = "Warp Yarns";
    } else if (this.props.moduleId == "warpYarnsTexturedAttribute") {
      fabricDetailTypeCode = "Warp Yarn Textured";
      pageTitle = "Warp Yarn Textured";
      moduleCaption = "Warp Yarn Textured";
    } else if (this.props.moduleId == "warpYarnsTwistedAttribute") {
      fabricDetailTypeCode = "Warp Yarn Twisted";
      pageTitle = "Warp Yarn Twisted";
      moduleCaption = "Warp Yarn Twisted";
    } else if (this.props.moduleId == "washedAttribute") {
      fabricDetailTypeCode = "Washed";
      pageTitle = "Washed";
      moduleCaption = "Washed";
    }

    this.state.fabricDetailTypeCode = fabricDetailTypeCode;
    this.state.pageTitle = pageTitle;
    this.state.moduleCaption = moduleCaption;
  };
  cleardata = () => {
    let fabricDetailData = new FabricDetailBean();
    fabricDetailData.companyCode = this.companyCode;
    this.setState({ fabricDetailData: fabricDetailData });
  };
  saveFabricDetailResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeFabricDetailEntryForm();
  };

  saveFabricDetail = () => {
    let input = this.state.fabricDetailData;
    if (input.isFetched == true) {
      if (SecurityAccessManager.FabricDetailMaintenanceEdit_IsAccessible()) {
        MasterService.updateFabricDetail(
          input,
          this.saveFabricDetailResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.FabricDetailMaintenanceCreate_IsAccessible()) {
        MasterService.createFabricDetail(
          input,
          this.saveFabricDetailResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editFabricDetailResponse = (response) => {
    if (response.data != null) {
      if (response.data.fabricDetail != null) {
        let fabricDetail = response.data.fabricDetail;
        this.setState({
          fabricDetailData: fabricDetail,
        });
        this.disable();
      }
      this.openFabricDetailEntryForm();
    }
  };

  editFabricDetail = (fabricDetailData) => {
    let criteria = new FabricDetailSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = fabricDetailData.code;
    criteria.fabricDetailType = fabricDetailData.fabricDetailTypeCode;
    if (SecurityAccessManager.FabricDetailMaintenanceView_IsAccessible()) {
      MasterService.readFabricDetail(
        criteria,
        this.editFabricDetailResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let fabricDetailData = this.state.fabricDetailData;
    fabricDetailData[e.target.name] = e.target.value;
    this.setState({
      fabricDetailData: fabricDetailData,
    });
  };
  enterKeyEventHandler = () => {
    this.opentypeforms();
  };
  opentypeforms = () => {
    let fabricDetailData = this.state.fabricDetailData;
    this.editFabricDetail(fabricDetailData);
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  save = () => {
    this.saveFabricDetail();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeFabricDetailEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openFabricDetailEntryForm = () => {
    this.setState({
      isFabricDetailListFormOpen: false,
      isFabricDetailEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeFabricDetailEntryForm = () => {
    this.clearError();
    let pageTitle = this.state.moduleCaption;
    this.setState({
      isFabricDetailListFormOpen: true,
      isFabricDetailEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadFabricDetailPage(criteria, pageInput);
  };
  loadFabricDetailPage = (criteria, pageList) => {
    let requestInput = new RestFabricDetailListRequest();
    requestInput.searchCriteria = criteria;
    requestInput.pageInput = pageList;
    this.state.pageList = pageList;
    if (SecurityAccessManager.FabricDetailMaintenanceView_IsAccessible()) {
      MasterService.getFabricDetailsPageList(
        requestInput,
        this.loadPageResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPageResponse = (response) => {
    if (response.data != null && response.data.fabricDetailPageList != null) {
      let fabricDetails_list = new Array();
      if (!isEmptyArray(response.data.fabricDetailPageList.fabricDetails)) {
        let fabricDetails = response.data.fabricDetailPageList.fabricDetails;
        fabricDetails.map((Info) => {
          let fabricDetailTypeCode = this.state.fabricDetailTypeCode;
          if (Info.fabricDetailTypeCode == fabricDetailTypeCode) {
            fabricDetails_list.push(Info);
          }
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount = response.data.fabricDetailPageList.totalCount;
      pageList.currentPage = response.data.fabricDetailPageList.currentPage;
      pageList.pageSize = response.data.fabricDetailPageList.pageSize;

      this.setState({
        fabricDetail_list: fabricDetails_list,
        pageList: pageList,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.fabricDetail_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ fabricDetail_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}

        {this.state.isFabricDetailListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isFabricDetailListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}

        {this.state.isFabricDetailListFormOpen && (
          <FabricDetailListForm
            {...this.state}
            onChange={this.onChange}
            opentypeforms={this.opentypeforms}
            enterKeyEventHandler={this.enterKeyEventHandler}
            editFabricDetail={this.editFabricDetail}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isFabricDetailEntryFormOpen && (
          <FabricDetailEntryForm {...this.state} onChange={this.onChange} />
        )}
      </div>
    );
  }
}

function FabricDetailAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <FabricDetailList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default FabricDetailAttributeModule;
